import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import { green, grey, orange, yellow } from '@material-ui/core/colors';


import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Typography} from '@material-ui/core'
import {Button, TextField} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';

import PersonIcon from '@material-ui/icons/Person';
import GroupIcon from '@material-ui/icons/Group';

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getObjectByID } from '../../../api/helpers';

class SelectObjectDialog_ extends React.Component{

    constructor(props){
        super(props)

        //console.log('this.props.networks')
        //console.log(this.props.networks)
        

        let panelsExpanded = {}
        let defaultNetID = this.props.networkID ? this.props.networkID : ( this.props.networks ? this.props.networks[0].ID : null)
        if(defaultNetID) panelsExpanded[defaultNetID] = true

        this.state = {
            changed: false,
            panelsExpanded: panelsExpanded,
            userFilter: '',
            errors: {
                userName: false
            },
            selected : {
                networkID: null,
                object: null
            }
        }

        this.nets = []

        this.handleSelect = this.handleSelect.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleFilterInput = this.handleFilterInput.bind(this)
    }

    handleSelect(){
        if(this.validate()){
            this.props.onAction({type: 'SELECT_OBJECT_DIALOG_SELECT', ...this.state.selected })
        }
    }

    handleClose(){
        this.props.onAction({type: 'SELECT_OBJECT_DIALOG_CLOSE'})
    }

    handleFilterInput(event){
        const val =  event.target.value
        console.log('handleFilterInput')
        console.log(event.target.name +' = ' +val)

        this.setState({[event.target.name]: val})
    }

    validate(){
        let error = false

        return !error;
    }


    togglePanel(event, expanded, panel){
        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })
    }

    isSelected(netID, object){
        //console.log('isSelected')
        //console.log(this.state.selected)
        //console.log(netID + ' ' + userID)


        let selected = this.state.selected
        //console.log('selected')
        //console.log(selected)

        let isSelected = netID === selected.networkID && object.id === selected.object.id

        //console.log('isSelected='+ (isSelected?'true':'false'))

         return isSelected
    }


    getRowStyle(netID, object){
        let style = {
            background: this.isSelected(netID, object) ? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    select(netID, object){
        //let network = getObjectByID(netID, this.nets)
        //let object = getObjectByID(object.ID, network.Objects)

        //console.log('select')
        //console.log(netID)
        //console.log(userID)

        let selected = {
            networkID: netID,
            object: object
        }
        //console.log('selected')
        //console.log(selected)

        this.setState({selected: selected})
    }

    selectClose(netID, object){
        //let network = getObjectByID(netID, this.props.networks)
        //let user = getObjectByID(userID, network.users)

        let selected = {
            networkID: netID,
            object: object
        }

        if(this.validate()){
            this.props.onAction({type: 'SELECT_OBJECT_DIALOG_SELECT', ...selected })
        }
    }

    getObjects(users, groups){

        //console.log('getObjects')
        //console.log(users)
        //console.log(groups)

        let u = users.map(item => ({
            id: item.ID, 
            name: item.Name,
            GUID: item.GUID,
            type: 3,
            color: item.DeviceID ? "primary" : "disabled"
        }) )

        let g = groups.map(item => ({
            id: item.ID, 
            name: item.Name,
            GUID: item.GUID,
            type: item.Type==0 ? 5 : 26,
            color: item.Type==0 ? 'inherit': 'error'
        }) )

        let objects = [...u,  ...g]


        if(this.props.types){

            //alert(this.props.types.includes())

            objects = objects.filter(
                item => this.props.types.includes(item.type)
                    //item.name.toLowerCase().indexOf(filter) >= 0 
            )
            
        }


        let filter = this.state.userFilter.toLowerCase()
        if(filter){
            //console.log('objects before filter')
            //console.log(objects)
            objects =  objects.filter(item => item.name.toLowerCase().indexOf(filter) >= 0 )
            //console.log('networks filter')
            //console.log(networks)
        }

        objects.sort((item1, item2) => (item1.type < item2.type || item1.name > item2.name ))

        return objects
    }

    getObjectIcon(networkID, object){

        if(object.type==3){
            return(<PersonIcon color={object.color} />)
        }else if(object.type==5){
            const yColor = yellow[900];
            return(<GroupIcon color={object.color} style={{color:yColor}} />)
        }else if(object.type==26){
            const yColor = green[600];
            return(<GroupIcon color={object.color} style={{color:yColor}} />)
        }else{
            return (<></>)
        }

    }


    render(){
        const {t} = this.props


        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            icon:{
                width: 30
            },
            addIcon: {
                color: 'white'
            }
        };

        const title = t('SelectItem')

        //const margin = {margin:'16px 0 8px 0'}

        //console.log('render SelectExternalNetworkGroupDialog')
        //console.log(this.props)

        let networks = []
        if(this.props.networkID){
            //console.log('single network ')
            //console.log(this.props.networks)
            networks = this.props.networks.filter(net => net.ID==this.props.networkID)
            console.log(networks)
        }else{
            networks = this.props.networks
        }


        /*
        let filter = this.state.userFilter.toLowerCase()
        
        if(filter){
            console.log('networks before filter')
            console.log(networks)
            networks = networks.map(
                net => ({
                            ID: net.ID, 
                            Name: net.Name,
                            users: net.users.filter(
                                item => item.Name.toLowerCase().indexOf(filter) >= 0 
                            )
                        })
            )
            //console.log('networks filter')
            //console.log(networks)
        }
        */

        this.nets = networks.map(net => ({
            ID: net.ID, 
            Name: net.Name,
            Objects: this.getObjects(net.users, net.groups)
        }))

        //this.objects = this.getObjects(net.users, net.groups)

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>        

            <Box textAlign="center">
                <TextField
                    name="userFilter"
                    id="userFilter"
                    onChange={this.handleFilterInput}
                    label={t("Filter")}
                    value={this.state.userFilter}
                    style={{width:'100%'}}
                    error={false}
                    autoComplete="new-password"
                />
            </Box>

            {this.nets.map(net=>(

            <ExpansionPanel key={net.ID}
                expanded={this.state.panelsExpanded[net.ID]==undefined?false:this.state.panelsExpanded[net.ID]} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, net.ID)}>
                <ExpansionPanelSummary style={{background: grey[300]}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{net.Name}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block', margin:0, padding:0}}>
                    
                    <Table size="small">

                    <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}></TableCell>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                            </TableRow>
                        </TableHead>
                    
                    <TableBody>
                    {net.Objects.map(object=>
                    <TableRow key={object.id}  
                        onClick={event=>this.select(net.ID, object)}
                        onDoubleClick={event=>this.selectClose(net.ID, object)}
                        style={this.getRowStyle(net.ID, object)}>
                        <TableCell>
                            {this.getObjectIcon(net.ID, object)}
                        </TableCell>
                        <TableCell>
                            {object.name}
                        </TableCell>
                    </TableRow>
                    )}
                    </TableBody>
                    </Table>

                </ExpansionPanelDetails>
            </ExpansionPanel>
            ))}

            

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSelect} variant="contained" color="primary">
            {t('Select')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        )

    }
}

export const SelectObjectDialog = withTranslation()(SelectObjectDialog_);